enum AgencyGroupStatus {
    Active = 90,
    Deleted = 100
}

export default AgencyGroupStatus;